<template>
    <div class="jsonEditor">
        <div class="jsonEditor__saveBtnWrapper">
            <b-button
                variant="primary"
                @click.prevent="saveChanges"
                :disabled="!isChanged"
                size="sm"
                >
                <icon name="save" />
                Save
            </b-button>
        </div>
        <json-view :parsedData="parsedData"></json-view>
    </div>
</template>


<script>
export default {
    name: 'JsonEditor',
    props: { 'objData': { required: true }, path: { type: String } },
    data: function() {
        return {
            'parsedData': []
        }
    },
    computed: {
        isChanged () {
            let input = JSON.stringify(this.makeJson(this.jsonParse(this.objData)))
            let output = JSON.stringify(this.makeJson(this.parsedData))
            return input != output
        }
    },
    watch: {
        objData () {
            if (this.objData) this.parsedData = this.jsonParse(this.objData)
            else this.parsedData = {}
        }
    },
    methods: {
        'jsonParse': function (jsonStr) {
            let parseJson = (json) => {
                let result = []
                let keys = Object.keys(json)
                keys.forEach((k, index) => {
                    let val = json[k]
                    let parsedVal = val
                    if(this.getType(val) == 'object') {
                        parsedVal = parseJson(val)
                    } else if(this.getType(val) == 'array') {
                        parsedVal = parseArray(val)
                    }

                    let opt = {
                        'name': k,
                        'type': this.getType(val)
                    }

                    if(opt.type == 'array' || opt.type == 'object') {
                        opt.childParams = parsedVal
                        opt.remark = null
                    } else {
                        opt.childParams = null
                        opt.remark = parsedVal
                    }

                    result.push(opt)
                })
                return result
            }

            //
            let parseArray = (arrayObj) => {
                let result = []
                for (let i = 0; i < arrayObj.length; ++i) {
                    let val = arrayObj[i]
                    let parsedVal = val
                    if (this.getType(val) == 'object') {
                        parsedVal = parseJson(val)

                    } else if (this.getType(val) == 'array') {
                        parsedVal = parseArray(val)
                    }


                    let opt = {
                        'name': null,
                        'type': this.getType(val)
                    }

                    if(opt.type == 'array' || opt.type == 'object') {
                        opt.childParams = parsedVal
                        opt.remark = null
                    } else {
                        opt.childParams = null
                        opt.remark = parsedVal
                    }

                    result.push(opt)
                }
                return result
            }

            // --
            let parseBody = (json) => {
                let r = parseJson(json)
                return r
            }

            return parseBody(jsonStr)
        },

        'getType': function(obj) {
            switch (Object.prototype.toString.call(obj)) {
                case '[object Array]': 
                    return 'array'
                    break
                case '[object Object]':
                    return 'object'
                    break
                default:
                    return typeof(obj)
                    break
            } 
        },

        'makeJson': function (dataArr) {

            let revertWithObj = function(data) {
                let r = {}
                for(let i = 0; i < data.length; ++i) {
                    let el = data[i]
                    let key, val
                    key = el.name
                    if(el.type == 'array') {
                        val = revertWithArray(el.childParams)

                    } else if (el.type == 'object') {
                        val = revertWithObj(el.childParams)

                    } else {
                        val = el.remark
                    }

                    r[key] = val
                }
                return r
            }

            let revertWithArray = function(data) {
                let arr = []
                for(let i = 0; i < data.length; ++i) {
                    let el = data[i]
                    let r
                    if(el.type == 'array') {
                        r = revertWithArray(el.childParams)
                    } else if (el.type == 'object') {
                        r = revertWithObj(el.childParams)
                    } else {
                        r = el.remark
                    }
                    
                    arr.push(r)
                }
                return arr
            }

            let revertMain = function (data) {
                let r = revertWithObj(data)
                return r
            } 

            return revertMain(dataArr)
        },
        saveChanges () {
            this.$emit('onSave', this.makeJson(this.parsedData), this.path)
        }
    },
    created: function() {
        this.parsedData = this.jsonParse(this.objData)
    }
}

</script>

<style lang="less">
@import url('./assets/styles/common.less');
</style>



// WEBPACK FOOTER //
// src/components/JsonEditor/JsonEditor.vue